module.exports = __webpack_public_path__ + "static/SnakeB-e59f545e0342006e83eb12d6f102a0e3.gif";